// @ts-nocheck
import { catchAsync } from './api';
import axios from './axios';
import { FILE_EXTENSIONS } from './constants';

export const exportFile = catchAsync(async ({ requestUrl, params, fileName }) => {
    const response = await axios.get(requestUrl, {
        responseType: 'blob',
        params,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    link.setAttribute('download', fileName);
    link.click();
});

export const generateFileExtension = (fileName, exportType) => {
    return `${fileName}.${FILE_EXTENSIONS[exportType]}`;
};

export const generateExportDocuments = () => {
    return [{ type: 'pdf' }, { type: 'excel' }];
};
